// IE11 is a bit broken if we import the module as usual so lets import the
// compiled js directly to fix it...
import Swiper from '../../../node_modules/swiper/js/swiper';

export default class SwiperJS {
    constructor() {
        const swipperWrappers = document.querySelectorAll('.js-swiper');

        if (swipperWrappers) {
            SwiperJS.init(swipperWrappers);
        }
    }

    static init(node) {
        node.forEach((swipperWrapper) => {
            // eslint-disable-next-line no-unused-vars
            let loop = true;
            if (swipperWrapper.dataset.loop) {
                loop = swipperWrapper.dataset.loop === '1';
            }
            // eslint-disable-next-line no-unused-vars
            const item = new Swiper(
                swipperWrapper,
                {
                    autoplay: swipperWrapper.dataset.autoplay
                        ? { delay: swipperWrapper.dataset.autoplay }
                        : false,
                    slidesPerView: swipperWrapper.dataset.slidesPerViewXs ?? 1,
                    slidesPerGroup: 1,
                    slidesPerColumnFill: swipperWrapper.dataset.slidesPerColumnFill ? swipperWrapper.dataset.slidesPerColumnFill : 'column',
                    speed: 800,
                    autoHeight: swipperWrapper.dataset.autoHeight ? (swipperWrapper.dataset.autoHeight === 'true') : true,
                    loop,
                    watchSlidesProgress: true,
                    effect: swipperWrapper.dataset.effect || 'slide',
                    fadeEffect: {
                        crossFade: true,
                    },
                    spaceBetween: swipperWrapper.dataset.spaceBetween ?? 0,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: swipperWrapper.dataset.next ? `.${swipperWrapper.dataset.next}` : '.swiper-button-next',
                        prevEl: swipperWrapper.dataset.prev ? `.${swipperWrapper.dataset.prev}` : '.swiper-button-prev',
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: swipperWrapper.dataset.slidesPerViewSm ?? (swipperWrapper.dataset.slidesPerView ?? 1),
                        },
                        768: {
                            slidesPerView: swipperWrapper.dataset.slidesPerViewMd ?? (swipperWrapper.dataset.slidesPerView ?? 1),
                            slidesPerGroup: swipperWrapper.dataset.slidesPerGroupMd ?? 1,
                            slidesPerGroupSkip: swipperWrapper.dataset.slidesPerGroupSkip ?? 0,
                        },
                        1024: {
                            slidesPerView: swipperWrapper.dataset.slidesPerViewLg ?? (swipperWrapper.dataset.slidesPerView ?? 1),
                            slidesPerGroup: swipperWrapper.dataset.slidesPerGroupLg ?? 1,
                            slidesPerGroupSkip: swipperWrapper.dataset.slidesPerGroupSkip ?? 0,
                        },
                        1220: {
                            slidesPerView: swipperWrapper.dataset.slidesPerView ?? 1,
                            slidesPerGroup: swipperWrapper.dataset.slidesPerGroup ?? 1,
                            slidesPerGroupSkip: swipperWrapper.dataset.slidesPerGroupSkip ?? 0,
                        },
                    },
                },
            );
        });
    }
}
